import { motion } from "framer-motion";
import { Drill, Ruler, Cable, CircleDashed, Route, GitBranch, ArrowUpRight } from "lucide-react";
import { SERVICES } from "../lib/data";

const ICONS = { Drill, Ruler, Cable, CircleDashed, Route, GitBranch };

export default function Services() {
  return (
    <section id="leistungen" className="relative py-20 md:py-28 bg-ink" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-center gap-4 mb-12">
          <span className="h-px w-12 bg-volt/50" />
          <h2 className="font-heading font-bold uppercase tracking-[0.15em] text-xl md:text-2xl text-white text-center">Unsere Spezialgebiete</h2>
          <span className="h-px w-12 bg-volt/50" />
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <motion.div key={s.title} data-testid={`service-card-${s.title}`}
                initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
                transition={{ duration: 0.55, delay: (i % 3) * 0.1 }}
                className="group relative rounded-2xl overflow-hidden bg-ink-surface border border-white/[0.06] hover:border-volt transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_24px_60px_rgba(0,0,0,0.6)]">
                <div className="relative h-52 overflow-hidden">
                  <img src={s.img} alt={s.title} loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-110" />
                  <div className="absolute inset-0 bg-gradient-to-t from-ink-surface via-ink-surface/30 to-transparent" />
                  <span className="absolute top-4 left-4 grid place-items-center h-12 w-12 rounded-xl bg-black/60 backdrop-blur-md border border-volt/40 text-volt group-hover:bg-volt group-hover:text-black transition-all duration-500">
                    <Icon className="h-5 w-5" strokeWidth={2} />
                  </span>
                  <ArrowUpRight className="absolute top-5 right-5 h-5 w-5 text-white/70 group-hover:text-volt group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all duration-400" />
                </div>
                <div className="p-7">
                  <h3 className="font-heading font-bold text-xl uppercase tracking-wide text-white group-hover:text-volt transition-colors">{s.title}</h3>
                  <p className="mt-2.5 text-white/55 text-sm leading-relaxed">{s.desc}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
